<template>
  <div>
    <van-popup
      class="compose-popup"
      :value="detailsVisible"
      position="bottom"
      closeable
      @click-close-icon="close"
      @click-overlay="close"
    >
      <div class="popup-wrapper">
        <div class="popup-title">成本构成</div>
        <div class="popup-body popup-body-with-footer">
          <hi-card v-for="(item, index) in composeList" :key="item.id || index">
            <div class="row-item" v-if="hasValue(item.seqCode)">
              <span class="label">序号:</span>
              <span class="value">{{ item.seqCode }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.costCompose)">
              <span class="label">成本构成:</span>
              <span class="value">{{ formatCompose(item.costCompose) }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.costComposeItem)">
              <span class="label">成本构成明细:</span>
              <span class="value">{{ formatCompose(item.costComposeItem) }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.sumAmount)">
              <span class="label">总价:</span>
              <span class="value">{{ item.sumAmount }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.commodityName)">
              <span class="label">大宗原料:</span>
              <span class="value">{{ item.commodityName }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.quotationUnit)">
              <span class="label">行情单位:</span>
              <span class="value">{{ item.quotationUnit | dictFilter(quotationUnitOptions) }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.quotationPrice)">
              <span class="label">最新行情单价:</span>
              <span class="value">{{ item.quotationPrice }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.supplyPrice)">
              <span class="label">与供方约定单价:</span>
              <span class="value">{{ item.supplyPrice }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.useQty)">
              <span class="label">用量:</span>
              <span class="value">{{ item.useQty }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.priceUnit)">
              <span class="label">核价单位:</span>
              <span class="value">{{ item.priceUnit | dictFilter(quotationUnitOptions) }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.lowerLimitPrice)">
              <span class="label">下限行情边界:</span>
              <span class="value">{{ item.lowerLimitPrice }}</span>
            </div>
            <div class="row-item" v-if="hasValue(item.upperLimitPrice)">
              <span class="label">上限行情边界:</span>
              <span class="value">{{ item.upperLimitPrice }}</span>
            </div>
          </hi-card>
        </div>
        <div class="popup-footer">
          <van-button class="footer-btn" type="info" @click="openSummary">汇总成本构成</van-button>
          <van-button class="footer-btn" type="info" @click="openCompare">对比成本库</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      class="summary-popup"
      :value="summaryVisible"
      position="bottom"
      closeable
      @click-close-icon="summaryVisible = false"
      @click-overlay="summaryVisible = false"
    >
      <div class="popup-wrapper">
        <div class="popup-title">汇总成本构成</div>
        <div class="popup-body">
          <div class="summary-actions">
            <van-button
              class="summary-btn"
              size="small"
              :type="summaryType === '1' ? 'info' : 'default'"
              @click="summaryType = '1'"
              >按成本项汇总</van-button
            >
            <van-button
              class="summary-btn"
              size="small"
              :type="summaryType === '2' ? 'info' : 'default'"
              @click="summaryType = '2'"
              >按成本构成汇总</van-button
            >
          </div>
          <div v-if="summaryType === '1'">
            <hi-card v-for="(item, index) in costItemDtoList" :key="item.costItem || index" :row-index="index + 1">
              <div class="row-item">
                <span class="label">成本项:</span>
                <span class="value">{{ formatCostItem(item.costItem) }}</span>
              </div>
              <div class="row-item">
                <span class="label">总价:</span>
                <span class="value">{{ item.sumAmount }}</span>
              </div>
              <div class="row-item">
                <span class="label">占比(%):</span>
                <span class="value">{{ item.ratio }}</span>
              </div>
            </hi-card>
          </div>
          <div v-else>
            <hi-card
              v-for="(item, index) in costComposeDtoList"
              :key="item.costCompose || index"
              :row-index="index + 1"
            >
              <div class="row-item">
                <span class="label">成本构成:</span>
                <span class="value">{{ formatCompose(item.costCompose) }}</span>
              </div>
              <div class="row-item">
                <span class="label">包含类别:</span>
                <span class="value">{{ formatCompose(item.costComposeItem) }}</span>
              </div>
              <div class="row-item">
                <span class="label">总价:</span>
                <span class="value">{{ item.sumAmount }}</span>
              </div>
              <div class="row-item">
                <span class="label">占比(%):</span>
                <span class="value">{{ item.ratio }}</span>
              </div>
            </hi-card>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      class="compare-popup"
      :value="compareVisible"
      position="bottom"
      closeable
      @click-close-icon="compareVisible = false"
      @click-overlay="compareVisible = false"
    >
      <div class="popup-wrapper">
        <div class="popup-title">对比成本库</div>
        <div class="popup-body">
          <hi-card v-for="(item, index) in compareList" :key="item.costCompose || index" :row-index="index + 1">
            <div class="row-item">
              <span class="label">成本构成:</span>
              <span class="value">{{ formatCompose(item.costCompose) }}</span>
            </div>
            <div class="row-item">
              <span class="label">成本构成明细:</span>
              <span class="value">{{ formatCompose(item.costComposeItem) }}</span>
            </div>
            <div class="row-item">
              <span class="label">变更前:</span>
              <span class="value">{{ item.originSumAmount }}</span>
            </div>
            <div class="row-item">
              <span class="label">变更后:</span>
              <span class="value" :class="{ 'red-text': item.currentSumAmount !== item.originSumAmount }">{{
                item.currentSumAmount
              }}</span>
            </div>
          </hi-card>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getComposeInfoByLineId, getCompareComposeByLineId, summaryComposeInfoByLineId } from '@/api/pmCostApplyCompose'
import { getAllCostCompose } from '@/api/pmCostComposeConfig'

export default {
  name: 'CostComposeDialog',
  props: {
    detailsVisible: {
      type: Boolean,
      default: false
    },
    lineId: {
      type: [String, Number],
      default: undefined
    }
  },
  data() {
    return {
      composeList: [],
      composeOptions: [],
      summaryVisible: false,
      compareVisible: false,
      summaryType: '1',
      costItemDtoList: [],
      costComposeDtoList: [],
      compareList: []
    }
  },
  computed: {
    quotationUnitOptions() {
      return this.$store.getters.dicts.quotation_price_unit
    },
    costItemOptions() {
      return this.$store.getters.dicts.cost_item
    }
  },
  watch: {
    detailsVisible(val) {
      if (val) {
        this.loadComposeData()
      }
    }
  },
  mounted() {
    this.loadComposeData()
  },
  methods: {
    async ensureComposeOptions() {
      if (!this.composeOptions.length) {
        const optionsResp = await getAllCostCompose()
        this.composeOptions = (optionsResp && optionsResp.data) || optionsResp || []
      }
    },
    async loadComposeData() {
      if (!this.lineId) {
        this.composeList = []
        return
      }
      await this.ensureComposeOptions()
      const response = await getComposeInfoByLineId(this.lineId)
      this.composeList = (response && response.data) || response || []
    },
    async loadSummaryData() {
      if (!this.lineId) {
        this.costItemDtoList = []
        this.costComposeDtoList = []
        return
      }
      await this.ensureComposeOptions()
      const response = await summaryComposeInfoByLineId(this.lineId)
      if (response && response.success === false) {
        this.$notify({ title: '提示', message: response.message, type: 'warning' })
        this.costItemDtoList = []
        this.costComposeDtoList = []
        return
      }
      const data = (response && response.data) || response || {}
      this.costItemDtoList = data.costItemDtoList || []
      this.costComposeDtoList = data.costComposeDtoList || []
    },
    async loadCompareData() {
      if (!this.lineId) {
        this.compareList = []
        return
      }
      await this.ensureComposeOptions()
      const response = await getCompareComposeByLineId(this.lineId)
      if (response && response.success === false) {
        this.$notify({ title: '提示', message: response.message, type: 'warning' })
        this.compareList = []
        return
      }
      this.compareList = (response && response.data) || response || []
    },
    formatCostItem(code) {
      if (code === null || code === undefined || code === '') {
        return code
      }
      const composeDict = (this.composeOptions || []).find(
        item => item.code !== null && item.code !== undefined && String(item.code) === String(code)
      )
      if (composeDict) {
        return composeDict.label || composeDict.labelDefault || composeDict.dictLabel || code
      }
      const dict = (this.costItemOptions || []).find(item => {
        const keys = [item.value, item.code, item.dictValue]
        return keys.some(key => key !== null && key !== undefined && String(key) === String(code))
      })
      if (!dict) {
        return code
      }
      return dict.label || dict.labelDefault || dict.dictLabel || code
    },
    formatCompose(code) {
      const dict = this.composeOptions.find(item => item.code === code)
      return dict ? dict.label || dict.labelDefault : code
    },
    hasValue(value) {
      return value !== null && value !== undefined && value !== ''
    },
    openSummary() {
      this.summaryVisible = true
      this.loadSummaryData()
    },
    openCompare() {
      this.compareVisible = true
      this.loadCompareData()
    },
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.compose-popup,
.summary-popup,
.compare-popup {
  height: 80vh;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}
.compose-popup {
  height: 90vh;
}
.popup-wrapper {
  height: 80vh;
  display: flex;
  flex-direction: column;
  position: relative;
}
.compose-popup .popup-wrapper {
  height: 90vh;
}
.popup-title {
  text-align: center;
  padding: 0 40px;
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  font-weight: 500;
  color: #333;
}
.popup-body {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 10px;
  background: #f7f8fa;
}
.popup-body-with-footer {
  padding-bottom: 56px;
}
.popup-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px 10px 12px;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  background: #fff;
  border-top: 1px solid #eee;
}
.summary-popup .label {
  width: 115px;
}
.summary-actions {
  display: flex;
  gap: 8px;
  padding: 15px 0 8px;
}
.row-item {
  display: flex;
  align-items: flex-start;
  padding: 1px 0;
  box-sizing: border-box;
}
.label {
  width: 135px;
  color: #666666;
  flex-shrink: 0;
}
.value {
  flex: 1;
  color: #262626;
  word-break: break-all;
}
.red-text {
  color: #e60012;
}
.footer-btn {
  flex: 1;
  border-radius: 5px;
  font-size: 16px;
  height: 37px;
}
.summary-btn {
  flex: 1;
  font-size: 16px;
  height: 35px;
  border-radius: 5px;
}

.compose-popup :deep(.van-popup__close-icon),
.summary-popup :deep(.van-popup__close-icon),
.compare-popup :deep(.van-popup__close-icon) {
  top: 11px;
}

:deep(.custom-card) {
  margin: 10px 5px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
:deep(.row-index) {
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #409eff;
  color: #fff;
}
</style>
